module.exports = __webpack_public_path__ + "img/sla.3fcbc14.svg";